import { useLayoutEffect } from "react";
import { HashRouter, Route, Routes, useLocation } from "react-router-dom";
import CalculatorGuidePage from "./components/CalculatorGuidePage";
import FrontPage from "./components/FrontPage";
import Guide from "./components/Guide";
import Saavutettavuusseloste from "./components/Saavutettavuusseloste";

// Scroll restoration
const Wrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    if (location.hash) {
      const targetElement = document.querySelector(location.hash);
      if (targetElement) targetElement?.scrollIntoView({ block: "start" });
      else document.documentElement.scrollTo(0, 0);
    } else {
      document.documentElement.scrollTo(0, 0);
    }
  }, [location.pathname]);
  return children;
};

export default function Router() {
  return (
    <HashRouter>
      <Wrapper>
        <Routes>
          <Route path="/guide" element={<Guide />} />
          <Route
            path="/saavutettavuusseloste"
            element={<Saavutettavuusseloste />}
          />
          <Route path="/calculator-guide" element={<CalculatorGuidePage />} />
          <Route exact path="*" element={<FrontPage />} />
        </Routes>
      </Wrapper>
    </HashRouter>
  );
}
